function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.286 3.982a.3.3 0 00.428 0L9.411.218a.3.3 0 01.428 0l.954.972a.3.3 0 010 .42L5.715 6.782a.3.3 0 01-.428 0L.206 1.61a.3.3 0 010-.42l.955-.972a.3.3 0 01.428 0l3.697 3.764z"
});

function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSelectArrow;